var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"my-4"},[_c('h4',[_vm._v(_vm._s(_vm.$t('lang.label.addcontacts')))]),_c('Form',{attrs:{"schema":_vm.schema,"default":_vm.model},on:{"save":function($event){return _vm.save($event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }